import { INeoAction } from '../Actions.interface';
import { STATUS, IMPORT_ACTIONS } from '../../Constants/Actions.constants';
import { isActionValid } from '../../Helpers/Reducer.helper';
import { IImport, ImportState } from '../../Models/DTO/Import.model';
import { parseISO, isBefore } from 'date-fns';

interface IImportReducerState {
  currentImport?: IImport;
  uploadStatus?: ImportState;
  isUploading: boolean;
  importList?: IImport[];
  isLoading: boolean;
}

const INITIAL_STATE: IImportReducerState = {
  isUploading: false,
  isLoading: false,
  importList: undefined,
};

const INCLUDED_IMPORT_ITEMS: ImportState[] = ['Processing', 'ProcessingFailed', 'Completed'];

const useValidActions = isActionValid(IMPORT_ACTIONS);

export default (state = INITIAL_STATE, action: INeoAction): IImportReducerState => {
  const { status, name, payload } = action;

  const actionValid = useValidActions(name);
  if (actionValid) {
    if (status === STATUS.SUCCESS) {
      switch (name) {
        case IMPORT_ACTIONS.GET_IMPORT:
          return {
            ...state,
            currentImport: payload,
          };
        case IMPORT_ACTIONS.POST_IMPORT:
          return {
            ...state,
            isUploading: false,
            currentImport: payload,
          };
        case IMPORT_ACTIONS.POST_IMPORT_FILE:
          return {
            ...state,
            isUploading: false,
          };
        case IMPORT_ACTIONS.GET_IMPORT_LIST:
          // Only get the last 5 imports sorted by date
          // TODO: Do this on the backend
          const imports: IImport[] = payload || [];
          return {
            ...state,
            importList: imports
              .filter((item) => INCLUDED_IMPORT_ITEMS.includes(item.status))
              .sort((a, b) => (isBefore(parseISO(a.createdDate), parseISO(b.createdDate)) ? 1 : -1))
              .slice(0, 5),
          };
      }
    }

    if (status === STATUS.LOADING) {
      switch (name) {
        case IMPORT_ACTIONS.POST_IMPORT:
        case IMPORT_ACTIONS.POST_IMPORT_FILE:
          return {
            ...state,
            isUploading: true,
          };
        case IMPORT_ACTIONS.GET_IMPORT_LIST:
          return {
            ...state,
            isLoading: true,
          };
      }
    }

    if (status === STATUS.FAILURE) {
      switch (name) {
        case IMPORT_ACTIONS.POST_IMPORT:
        case IMPORT_ACTIONS.POST_IMPORT_FILE:
          return {
            ...state,
            isUploading: false,
          };
        case IMPORT_ACTIONS.POST_IMPORT_FILE:
          return {
            ...state,
            isUploading: false,
            currentImport: {
              status: 'FileParsingFailed',
            } as IImport,
          };

        case IMPORT_ACTIONS.GET_IMPORT_LIST:
          return {
            ...state,
            isLoading: false,
          };
      }
    }
  }
  return state;
};
